import React from "react";
import { AppBar, Box, Toolbar } from "@mui/material";
import LanguageSwitcher from "@components/LanguageSwitcher";
import ProfileMenu from "@components/ProfileMenu";
import MobileNav from "@layouts/MobileNav";

interface HeaderProps {
  children?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({ children }) => {
  return (
    <AppBar position="sticky" className="bg-white text-gray-800">
      <Toolbar>
        <Box sx={{ flexGrow: { xs: 1 } }}>
          <MobileNav />
        </Box>
        <Box className="gap-2" sx={{ display: { xs: "flex" } }}>
          <LanguageSwitcher />
          <ProfileMenu />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
